import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86bab318"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"padding":"7px 12px 0px 16px"},
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 엔젤리그 조합 정보 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 조합정보 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 투자 금액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 주당 매수가 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 보유 주식수 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 조합원 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 리드엔젤 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          mt: "safeAreaTop",
          dp: "flex",
          "align-items": "center",
          pt: "3px 0px 20px 0px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              class: "ion-activatable ripple-parent",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({name:'home'})))
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, { bg: "bg1" }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          bg: "bg1",
          direction: "column",
          "justify-content": "space-between"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              dp: "flex",
              bg: "white",
              pt: "8px",
              px: "20px",
              "align-items": "center",
              style: {"border-bottom":"8px solid #F6F8FB"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_img, {
                  width: "60px",
                  height: "60px",
                  src: "/assets/image/angel_logo.png"
                }),
                _createVNode(_component_ag_text, { typography: "tit20b" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_box, {
              bg: "white",
              dp: "flex",
              "justify-content": "center",
              direction: "column",
              "align-items": "center",
              py: "24px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_img, {
                  dp: "block",
                  mb: "8px",
                  width: "40px",
                  height: "40px",
                  src: _ctx.partnershipInfo.partnershipLogo
                }, null, 8, ["src"]),
                _createVNode(_component_ag_text, { typography: "tit20b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.partnershipInfo.partnershipName) + " 정보 ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_box, { class: "white-box" }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_text, {
                  dp: "block",
                  typography: "tit16b"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text, {
                  dp: "block",
                  typography: "main12r",
                  "text-align": "right",
                  color: "gray2",
                  mb: "8px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formattedDate(_ctx.partnershipInfo.foundAt)) + " 설립 ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  mb: "8px",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, { typography: "tit14b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.expectTotalAmountFrom)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text, { typography: "main14r" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  mb: "8px",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, { typography: "tit14b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.purchsePrice)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text, { typography: "main14r" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  mb: "8px",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_box, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, { typography: "tit14b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.totalQty)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_text, { typography: "main14r" }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  mb: "8px",
                  dp: "flex",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.partnershipInfo.investorCount) + "명 ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "main14r" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.partnershipInfo.leadAngel), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}